// extracted by mini-css-extract-plugin
export var displayNone = "_q4-6";
export var imgContainer = "_q4-2";
export var overflowHidden = "_q4-3";
export var productInfoCardButtonContainer = "_q4-5";
export var productTitleText = "_q4-4";
export var rightArrow = "_q4-1";
export var rightArrowContainer = "_q4-0";